import { Box, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import FilterDropDown from '../components/filterDropDown/FilterDropDown';
import Content from '../components/Layout/Content';
import { VitalDataTiles } from '../components/VitalDataTiles/VitalDataTiles';
import { dateFilterMenuItems, VITALS_LABELS } from '../shared/constants';
import { handleTimeFilter } from '../shared/helper';
import { VITALS } from '../shared/Strings';

export const VitalAllData = () => {
  const { vitalType } = useParams();
  const { state } = useLocation();
  const allData = state?.data ?? [];
  const isBpGraph = state?.isBpGraph ?? false;
  const [filteredData, setFilteredData] = useState(allData);
  const [timeFilter, setTimeFilter] = useState(dateFilterMenuItems[0].value);

  const vitalLabel = VITALS_LABELS[vitalType];

  const breadcrumbData = [
    { label: 'Medical', route: '/medical' },
    { label: 'Vitals', route: '/medical/vitals' },
    { label: vitalLabel, route: `/medical/vitals/${vitalType}`, state: state },
    { label: 'All Data' },
  ];

  const dateFilterOptions = {
    options: dateFilterMenuItems,
    value: timeFilter,
    changeHandler: ev => {
      const filterVal = ev.target.value;
      setTimeFilter(filterVal);
      const filterResData = handleTimeFilter(filterVal, allData);
      setFilteredData(filterResData);
    },
  };

  if (!state) {
    return <Navigate to={'/medical/vitals'} />;
  }

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{VITALS_LABELS.ALL_DATA}</Typography>
      <>
        <Box sx={{ display: 'flex', position: 'relative', marginTop: '20px' }}>
          <FilterDropDown {...dateFilterOptions} />
        </Box>
        <Box sx={{ mt: 4 }}>
          {!filteredData.length ? (
            <Typography variant="h3">{VITALS.NO_DATA_FOUND}</Typography>
          ) : (
            filteredData.map((cardData, i) => {
              return (
                <VitalDataTiles data={cardData} key={i} isBpGraph={isBpGraph} />
              );
            })
          )}
        </Box>
      </>
    </Content>
  );
};
